import type { ReactNode } from 'react';

export const symbol_person_pin_circle: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-159q133-121 196.5-219.5T740-552q0-118-75.5-193T480-820q-109 0-184.5 75T220-552q0 75 65 173.5T480-159Zm-21.5 55.5Q448-107 440-115q-42-38-91-87.5T258-309q-42-57-70-119t-28-124q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 62-28 124t-70 119q-42 57-91 106.5T520-115q-8 8-18.5 11.5T480-100q-11 0-21.5-3.5ZM480-560Zm75.5 174.5Q592-401 618-430q4-5 6-10t2-10q0-8-4-15t-12-12q-30-17-63-25t-67-8q-34 0-67 8t-63 25q-7 5-11 12t-4 15q0 5 1.5 10t5.5 10q26 29 62.5 44.5T480-370q39 0 75.5-15.5ZM480-570q29 0 49.5-20.5T550-640q0-29-20.5-49.5T480-710q-29 0-49.5 20.5T410-640q0 29 20.5 49.5T480-570Z"
		/>
	</svg>
);
